import React from "react";

import { Form, Input } from "antd";

const { Item } = Form;
const SpecificDetails = () => {
  return (
    <>
      <Item labelCol={{ span: 24 }} label="Serial Number" name="serialNo">
        <Input />
      </Item>
      <Item labelCol={{ span: 24 }} label="Notes" name="notes">
        <Input.TextArea />
      </Item>
    </>
  );
};

export default SpecificDetails;
